import { IIconBase } from '..'

const moveTabIcon = ({
  color = '#D7DBEC',
  height = 12,
  width = 12,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/textalign-position'>
        <g id='arrow-3'>
          <g id='Group'>
            <path
              id='Vector'
              d='M3.36523 10.5V1.5'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_2'
              d='M5.86523 1.5V10.5'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_3'
              d='M8.5 1.5V10.5'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default moveTabIcon
